import React, { useState } from "react"
import axios from "axios"
import { Formik, Form, Field, ErrorMessage } from "formik"
import * as Yup from "yup"

import Layout from "../components/layout"
import SEO from "../components/seo"

import "../utils/normalize.css"
import "../utils/css/screen.css"

const formSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email")
    .required("Required"),
  message: Yup.string().required("Required"),
})

const ContactPage = props => {
  const [serverState, setServerState] = useState()
  const handleServerResponse = (ok, msg) => {
    setServerState({ ok, msg })
  }

  const handleOnSubmit = (values, actions) => {
    axios({
      method: "POST",
      url: "https://formspree.io/f/xeqpwkgn",
      data: values,
    })
      .then(response => {
        actions.setSubmitting(false)
        actions.resetForm()
        handleServerResponse(true, "Thanks!")
      })
      .catch(error => {
        actions.setSubmitting(false)
        handleServerResponse(false, error.response.data.error)
      })
  }

  return (
    <Layout location={props.location} title={"Contact"}>
      <SEO title="Contact" description="" />
      <article className="post-content">
        <h1>Contact</h1>
        <Formik
          initialValues={{ email: "", message: "" }}
          onSubmit={handleOnSubmit}
          validationSchema={formSchema}
        >
          {({ isSubmitting }) => (
            <Form id="fs-frm" noValidate>
              <label htmlFor="email">Email:</label>
              <Field id="email" type="email" name="email" />
              <ErrorMessage name="email" className="errorMsg" component="p" />
              <label htmlFor="message">Message:</label>
              <Field id="message" name="message" component="textarea" />
              <ErrorMessage name="message" className="errorMsg" component="p" />
              <button type="submit" disabled={isSubmitting}>
                Submit
              </button>
              {serverState && (
                <p className={!serverState.ok ? "errorMsg" : ""}>
                  {serverState.msg}
                </p>
              )}
            </Form>
          )}
        </Formik>
      </article>
    </Layout>
  )
}

export default props => <ContactPage location={props.location} {...props} />
